import { customRangeToApi, presetToRange, toApiIsoSeconds } from 'views/Admin/_shared/dateApi';
import { PeriodSelection } from 'views/Admin/UsageReport/types';
import { AuditLogFilters, AuditLogQueryParams, AuditLogSort, MIN_KEYWORD_LENGTH } from './types';

/** Serializes a sort into the backend key convention: bare = ASC, leading '-' = DESC. */
export const sortToParam = (sort: AuditLogSort): string => (sort.direction === 'DESC' ? `-${sort.field}` : sort.field);

/** Converts the selected period (preset or custom) into inclusive start/end ISO timestamps. */
export const periodToApiTimes = (period: PeriodSelection): { start_time: string; end_time: string } => {
  if (period.kind === 'custom') {
    const { from, to } = customRangeToApi(period.from, period.to);
    return { start_time: from, end_time: to };
  }
  const { from, to } = presetToRange(period.value);
  return { start_time: toApiIsoSeconds(from), end_time: toApiIsoSeconds(to) };
};

/** Builds the query params for an audit-log request from UI state. */
export const buildAuditLogParams = (
  filters: AuditLogFilters,
  page: number,
  pageSize: number,
  sort: AuditLogSort,
): AuditLogQueryParams => {
  const { start_time, end_time } = periodToApiTimes(filters.period);
  const trimmedKeyword = filters.keyword.trim();
  return {
    start_time,
    end_time,
    event_type: filters.eventType ?? undefined,
    keyword: trimmedKeyword.length >= MIN_KEYWORD_LENGTH ? trimmedKeyword : undefined,
    skip: page * pageSize,
    limit: pageSize,
    sort: sortToParam(sort),
  };
};
